import store from '../store';

const checkPayment = async () => {
  store.commit('setMonetizeSponsor', true);
};

export default {
  init: () => {
    checkPayment();
  },
};



// WEBPACK FOOTER //
// ./src/services/sponsorSvc.js